<template>
  <div
    class="radial-progress-bar"
    :style="styles"
    :title="title"
  >
    <span class="percentage">
      {{ percentageText }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'RadialProgressBar',
  props: {
    progress: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 40,
    },
    fontSize: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    background() {
      const color = `rgba(49, 123, 133, ${0.2 + this.progress * 0.8})`;

      return `conic-gradient(${color} ${this.progress * 100}%, #e2e2e2 0)`;
    },
    percentageText() {
      return `${(this.progress * 100).toFixed(0)}%`;
    },
    styles() {
      return `
        background: ${this.background};
        width: ${this.size}px;
        height: ${this.size}px;
        font-size: ${this.fontSize}px;
      `;
    },
  },
};
</script>

<style scoped>
.radial-progress-bar,
.percentage {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.radial-progress-bar {
  flex-shrink: 0;
}

.percentage {
  width: 75%;
  height: 75%;
  background-color: #ffffff;
}
</style>
